import React from 'react'
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";

import Menu from "../common/Menu/Menu";
import AndroidPaymentTitle from './AndroidPaymentTitle/AndroidPaymentTitle';
import AndroidPaymentContent from './AndroidPaymentContent/AndroidPaymentContent';

import LastBlogArticles from '../LastBlogArticles/LastBlogArticles'
import Footer from '../common/footer/Footer';
import GlobalLoader from "../GlobalLoader/GlobalLoader";

import { className } from '../../Utils';

import './AndroidPayment.css'

const AndroidPayment = () => {
    const { translations, language } = useSelector(state => state.home)

    return (
        <>
            <GlobalLoader showSpinner={translations[language] ? false : true} />
            <div className="App">
                <div id="main" className={className('android-payment-main')}>
                    <Menu mobile={isMobile} pageName='android-payment' />
                    <div id={"scrollContainer"} className="android-payment-main-container">
                        <AndroidPaymentTitle />
                        <AndroidPaymentContent />
                        {language === 'bg' &&
                            <LastBlogArticles sections="section03" />
                        }
                        <Footer />
                    </div>
                </div>
            </div>
        </>

    )
}

export default AndroidPayment